import React from 'react';

class FilterDivider extends React.Component {
	render() {
		return <div className="filter-divider" />;
	}
}

export default FilterDivider;
